import { KeyboardKey } from '@office-start/keystroke-handler-utility';
import { useEffect } from 'react';
import { maybeFocusLastHtmlElement } from './../utilities';
import { useLastActiveHtmlElement } from './useLastActiveHtmlElement';
/**
 * Handles keyboard events for the toast container
 * CTRL + F6 - Focus toast container
 * ALT+1 - perform CTA (if there is one)
 * Escape - Puts focus back on the last focused html element if user had focused the toast
 * @param containerHtmlElementRef container to listen for active elements
 * @param callToAction Optional call to action function
 */
export var useFocusToastContainer = function (containerHtmlElementRef, callToAction) {
    var lastFocusedHtmlElement = useLastActiveHtmlElement(containerHtmlElementRef);
    useEffect(function () {
        var containerHtmlElement = containerHtmlElementRef.current;
        var keyHandler = function (ev) {
            // Focus the container on CTRL+F6
            if (containerHtmlElement &&
                ev.ctrlKey &&
                ev.key === KeyboardKey.F6) {
                containerHtmlElement.focus();
            }
            // On Escape...go back to previous active element (if one exists) or blur
            if (ev.key === KeyboardKey.Escape) {
                maybeFocusLastHtmlElement(containerHtmlElement, lastFocusedHtmlElement);
            }
            // For the document listener, if presses alt+1
            if (ev.key === KeyboardKey.One && ev.altKey && callToAction) {
                callToAction();
            }
        };
        document.addEventListener('keydown', keyHandler);
        return function () {
            document.removeEventListener('keydown', keyHandler);
            maybeFocusLastHtmlElement(containerHtmlElement, lastFocusedHtmlElement);
        };
    }, [callToAction, containerHtmlElementRef, lastFocusedHtmlElement]);
};
//# sourceMappingURL=useFocusToastContainer.js.map